module.exports = __webpack_public_path__ + "media/images/about/structure-2c01c9ca72a057bb9333e540bf2def5b.png";